import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterModule } from '@angular/router';

interface Breadcrumb {
  title?: string;
  subTitle?: string;
  breadcrumb_path?: string;
  currentURL?: string;
  breadcrumb_url? : string
}

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [RouterModule, NgIf],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.css'
})
export class BreadcrumbComponent {

  @Input() breadcrumb: Breadcrumb = {};
  @Input() style2?: boolean = false;
  @Input() addProperty? : string = '';
  /** Optional second action rendered next to the addProperty button. */
  @Input() secondaryAction? : string = '';

  @Output() addEvent = new EventEmitter<boolean>();
  @Output() editPropertyBackButton = new EventEmitter<boolean>();
  @Output() secondaryEvent = new EventEmitter<boolean>();

  title: string = '';
  subTitle: string = 'Your business dashboard template';
  currentURL?: string = '';
  breadcrumb_path?: string = '';
  breadcrumb_url? : string = '';

  ngOnInit() {    
    this.title = this.breadcrumb.title || this.title;
    this.subTitle = this.breadcrumb.subTitle || this.subTitle;
    this.breadcrumb_path = this.breadcrumb.breadcrumb_path;
    this.currentURL = this.breadcrumb.currentURL;
    this.breadcrumb_url = this.breadcrumb.breadcrumb_url;    
  }

  toggleAddButton(){
    this.addEvent.emit(true);
  }

  toggleBackButton(){
    this.editPropertyBackButton.emit(true);
  }

  toggleSecondaryButton(){
    this.secondaryEvent.emit(true);
  }
  

}
